module.exports = __webpack_public_path__ + "img/pending_approval_popup.5e29b815.png";